import { Balance, ImportantDevices, TravelExploreOutlined } from "@mui/icons-material";
import { useRouter } from "next/router";
import React from "react";
import { Mercer } from "~/components/ui/core/icons/Mercer";
import { Link } from "~/components/ui/core/Link";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "~/components/ui/shadcn/ui/sidebar";
import { usePermissions } from "~/hooks/usePermissions";
import { useSession } from "~/hooks/useSession";
import { useI18n } from "~/lib/i18n/useI18n";

export const SidebarBenchmark: React.FC = () => {
  const { t } = useI18n();
  const { user } = useSession();
  const { permissions } = usePermissions();
  const router = useRouter();

  const showTrial = !user;
  const showMarketData = permissions.canAccessMarketData;
  const showComptryxMarketData = permissions.canSeeComptryxMarketData;
  const showGlobalSalaryConverter = true;

  const showSection = showTrial || showMarketData || showComptryxMarketData || showGlobalSalaryConverter;

  if (!showSection) return null;

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{t("components.layout.sidebar.benchmark")}</SidebarGroupLabel>
      <SidebarMenu>
        {showTrial && (
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              tooltip={t("components.layout.sidebar.market-data")}
              isActive={router.pathname === "/try/market-data"}
            >
              <Link to={{ pathname: "/try/market-data" }} noLinkStyle>
                <ImportantDevices />
                <span>{t("components.layout.sidebar.market-data")}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        )}

        {showMarketData && (
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              tooltip={t("components.layout.sidebar.market-data")}
              isActive={router.pathname === "/market-data"}
            >
              <Link to={{ pathname: "/market-data" }} noLinkStyle>
                <Balance />
                <span>{t("components.layout.sidebar.market-data")}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        )}

        {showComptryxMarketData && (
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              tooltip={t("components.layout.sidebar.comptryx-market-data")}
              isActive={router.pathname === "/market-data/comptryx"}
            >
              <Link to={{ pathname: "/market-data/comptryx" }} noLinkStyle>
                <Mercer />
                <span>{t("components.layout.sidebar.comptryx-market-data")}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        )}
        {showGlobalSalaryConverter && (
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              tooltip={t("components.layout.sidebar.global-salary-converter")}
              isActive={router.pathname.startsWith("/global-salary-converter/[from]/[to]/[amount]")}
            >
              <Link
                to={{
                  pathname: "/global-salary-converter/[from]/[to]/[amount]",
                  query: { from: "berlin", to: "paris", amount: "50000" },
                }}
                noLinkStyle
              >
                <TravelExploreOutlined />
                <span>{t("components.layout.sidebar.global-salary-converter")}</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        )}
      </SidebarMenu>
    </SidebarGroup>
  );
};
